import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const useFromMenu = ({ clearAfterRead }: { clearAfterRead?: boolean }) => {
  const [isFromMenu, setIsFromMenu] = useState<boolean | null>(null);
  const [hasProcessedParams, setHasProcessedParams] = useState(false);

  const { state: { fromMenu } = { fromMenu: false } } = useLocation<{ fromMenu?: boolean }>();

  const processParams = useCallback(() => {
    if (!hasProcessedParams) {
      setIsFromMenu(!!fromMenu);
      setHasProcessedParams(true);

      if (clearAfterRead && fromMenu) {
        /**
         * Clear the history state to avoid unintended persistence
         * We use replaceState to avoid triggering a new history entry
         */
        window.history.replaceState(null, '', location.pathname);
      }
    }
  }, [hasProcessedParams, fromMenu, clearAfterRead]);

  useEffect(() => {
    processParams();
  }, [processParams]);

  return isFromMenu;
};

export default useFromMenu;
